import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="relative min-h-[70vh] flex items-center justify-center px-4 text-center overflow-hidden">
      <div
        className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[34rem] h-[34rem]
                   rounded-full blur-3xl pointer-events-none animate-glow-pulse"
        style={{ background: 'radial-gradient(circle, rgba(143,82,201,0.16), transparent 65%)' }}
        aria-hidden="true"
      />

      <div className="relative animate-fade-up">
        <div className="font-display text-[7rem] sm:text-[9rem] leading-none font-extrabold
                        text-gradient-brand mb-2 select-none">
          404
        </div>
        <h1 className="font-display text-2xl font-bold text-white mb-3 tracking-tight">
          Page not found
        </h1>
        <p className="text-gray-500 mb-8 max-w-sm mx-auto">
          The page you're looking for doesn't exist or has been removed.
        </p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Link to="/" className="btn-primary px-7 py-3">Back to Home</Link>
          <Link to="/docs" className="btn-secondary px-7 py-3">Read the docs</Link>
        </div>
      </div>
    </div>
  );
}
